import { apiClient, signApiRequest } from ".";
import { useQuery } from "@tanstack/react-query";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";

export const getBookingStatus = async ({
  bookingId,
  credentials,
}: {
  bookingId: string;
  credentials: CustomerCredentials;
}) => {
  if (bookingId == "") {
    return;
  }
  const signedRequest = await signApiRequest(
    "GET",
    `${import.meta.env.VITE_API_URL}/user/booking?bookingId=${bookingId}`,
    credentials,
    {
      "content-type": "application/json",
    },
  );

  const response = await apiClient(signedRequest);
  const data = await response.data;

  return data;
};

export const useGetBookingStatus = ({
  bookingId,
  enabled,
  credentials,
}: {
  bookingId: string;
  enabled: boolean;
  credentials: CustomerCredentials;
}) => {
  const bookingStatusQuery = useQuery({
    queryKey: ["get-booking-status"],
    queryFn: () => getBookingStatus({ bookingId, credentials }),
    enabled,
    refetchInterval: 1000,
    retry: 10,
    throwOnError: (error) => {
      captureException(error, {
        tags: {
          operation: "get-booking-status",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/user/booking?bookingId=${bookingId}",
        },
        level: "error",
      });
      return true;
    },
  });
  return bookingStatusQuery;
};
